import React, { useState, useEffect } from "react";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { RescheduledInterviewAction } from "./../../../Redux/action/RescheduledInterviewAction";
import { TeamTableAction } from "./../../../Redux/action/TeamTableAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const UpdateInterview = (props) => {
    const [open, setOpen] = useState(false);
    const [startDate, setDate] = useState(new Date());
    const [data, setData] = useState({
        jobPosition: "",
        interviewMode: "",
        interviewLink: "",
        interviewStartTime: "",
        duration: "",
        inteviewType: "",
    });

    const {
        interviewMode,
        jobPosition,
        inteviewType,
        interviewerId,
        interviewLink,
        interviewStartTime,
        duration, } = data;

    const PlannedList = useSelector((state) => state.InterviewPlanned.result);
    const TeamList = useSelector((state) => state.TeamTable.result);

    const candidateId = props.data
    const { userResult } = useSelector((state) => state.Auth);
    let vendorId = userResult?.vendorid;
    useEffect(() => {
        dispatch(TeamTableAction(vendorId));
    }, []);

    const jobId = props.jobId
    const uuid = props.uuid
    const round = props.round + 1

    const defaultEndDate = new Date()
    defaultEndDate.setDate(defaultEndDate.getDate() + 7)
    const today = new Date()

    const selectDateHandler = (d) => {
        setDate(d)
    }

    const day = startDate.getDate()
    const month = startDate.getMonth() + 1
    const year = startDate.getFullYear()
    const interviewDate = year + "-" + month + "-" + day

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let dispatch = useDispatch();

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    let userData = PlannedList;

    useEffect(() => {
        if (userData) {
            setData({ ...userData });
        }
    }, [userData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let content = {
            vendorId,
            interviewMode,
            candidateId,
            jobId,
            uuid,
            inteviewType,
            round,
            interviewerId,
            interviewLink,
            interviewDate,
            interviewStartTime,
            duration,
        }
        dispatch(RescheduledInterviewAction(content));
    };

    return (
        <>
            <ToastContainer />
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Rescheduled Interview
                </BootstrapDialogTitle>
                <form onSubmit={handleSubmit}>
                    <Box
                        sx={{
                            width: 500,
                            maxWidth: "100%",
                        }}
                    >
                        <div className="label_job_schedule">
                            <select
                                style={{ height: "45px" }}
                                required
                                className="form-controll Select"
                                name="interviewerId"
                                value={interviewerId}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Interviewer</option>
                                {TeamList && TeamList.map((x, i) => {
                                    return <option key={i} value={x.candidateId}> {x.firstName}</option>;
                                })}
                            </select>
                        </div>
                        <div className="label_job_schedule">
                            <select
                                style={{ height: "45px" }}
                                required
                                className="form-controll Select"
                                name="inteviewType"
                                value={inteviewType}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Select Interview Type</option>
                                <option className="dropdown_option" value="TELEPHONIC">
                                    TELEPHONIC
                                </option>
                                <option className="dropdown_option" value="TECHNICAL">
                                    TECHNICAL
                                </option>
                                <option className="dropdown_option" value="HR">
                                    HR
                                </option>
                            </select>
                        </div>
                        <div className="label_job_schedule">
                            <select
                                style={{ height: "45px" }}
                                required
                                className="form-controll Select"
                                name="interviewMode"
                                value={interviewMode}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Select Interview Mode</option>
                                <option className="dropdown_option" value="REMOTE">
                                    REMOTE
                                </option>
                                <option className="dropdown_option" value="IN_PERSON">
                                    IN_PERSON
                                </option>
                            </select>
                        </div>
                        <TextField
                            fullWidth
                            label="Job Position"
                            name="jobPosition"
                            value={jobPosition}
                            onChange={handleInputChange}
                        />
                        <div className="label_job_schedule">
                            <DatePicker
                                style={{ width: "104%", height: "41px" }}
                                dateFormat="dd-MM-yyy"
                                selected={startDate}
                                onChange={selectDateHandler}
                                minDate={today}
                                todayButton={"Today"} />
                        </div>
                        <div className="label_job_schedule">
                            <select
                                style={{ height: "45px" }}
                                required
                                className="form-controll Select"
                                name="interviewStartTime"
                                value={interviewStartTime}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Select Start Time</option>
                                <option className="dropdown_option" value="17:30:33">
                                    17:30:33
                                </option>
                                <option className="dropdown_option" value="18:30:33">
                                    18:30:33
                                </option>
                                <option className="dropdown_option" value="19:30:33">
                                    19:30:33
                                </option>
                            </select>
                        </div>
                        <div className="label_job_schedule">
                            <select
                                style={{ height: "45px" }}
                                required
                                className="form-controll Select"
                                name="duration"
                                value={duration}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Select Duration</option>
                                <option className="dropdown_option" value="00:30:00">
                                    30 min
                                </option>
                                <option className="dropdown_option" value="00:45:00">
                                    45 min
                                </option>
                                <option className="dropdown_option" value="00:60:00">
                                    60 min
                                </option>
                            </select>
                        </div>
                        <TextField
                            fullWidth
                            label="Interview Link"
                            name="interviewLink"
                            value={interviewLink}
                            onChange={handleInputChange}
                        />
                    </Box>
                    <DialogActions>
                        <Button autoFocus type="submit">
                            Save changes
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>

            <div onClick={handleClickOpen}>Rescheduled</div>
        </>
    );
};

export default UpdateInterview;
